module.exports = __webpack_public_path__ + "static/img/home_case_02_zh.5d8f79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_02_zh.png
// module id = qvQh
// module chunks = 34